export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Customers',
          code: 'customers',
          multi: true,
          options: [
            {
              label: 'Subs',
              value: 1,
              selected: false
            },
            {
              label: 'Pros',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '18-34',
              value: 1,
              selected: false
            },
            {
              label: '35-54',
              value: 2,
              selected: false
            },
            {
              label: '55+',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Ethnicity',
          code: 'ethnicity',
          multi: true,
          options: [
            {
              label: 'White/Caucasian',
              value: 1,
              selected: false
            },
            {
              label: 'Black/African American',
              value: 2,
              selected: false
            },
            {
              label: 'Asian',
              value: 3,
              selected: false
            },
            {
              label: 'Asian Indian or East Indian',
              value: 4,
              selected: false
            },
            {
              label: 'Pacific Islander or Native Hawaiian',
              value: 5,
              selected: false
            },
            {
              label: 'American Indian or Alaska Native',
              value: 6,
              selected: false
            },
            {
              label: 'Middle Eastern/Arabic/Persian',
              value: 7,
              selected: false
            }
          ]
        },
        {
          label: 'Region',
          code: 'region',
          multi: true,
          options: [
            {
              label: 'East - NY Region',
              value: 1,
              selected: false
            },
            {
              label: 'East - TriState Region',
              value: 2,
              selected: false
            },
            {
              label: 'West - OMS Area - Mid-Atlantic',
              value: 3,
              selected: false
            },
            {
              label: 'West - OMS Area - Mid Central',
              value: 4,
              selected: false
            },
            {
              label: 'West - OMS Area - Texoma',
              value: 5,
              selected: false
            },
            {
              label: 'West - OMS Area - West Pacific',
              value: 6,
              selected: false
            }
          ]
        },
        {
          label: 'Service Usage',
          code: 'service_usage',
          multi: true,
          options: [
            {
              label: 'All Services (Mobile, Internet, TV, Voice)',
              value: 1,
              selected: false
            },
            {
              label: 'Mobile/Wireless Only',
              value: 2,
              selected: false
            },
            {
              label: 'Internet Only',
              value: 3,
              selected: false
            },
            {
              label: 'TV/Video Only',
              value: 4,
              selected: false
            },
            {
              label: 'Voice/Phone Only',
              value: 5,
              selected: false
            },
            {
              label: 'Mobile/Wireless and Internet Only',
              value: 6,
              selected: false
            },
            {
              label: 'Mobile/Wireless and TV/Video Only',
              value: 7,
              selected: false
            },
            {
              label: 'Mobile/Wireless and Mobile Wireless Only',
              value: 8,
              selected: false
            },
            {
              label: 'Internet and TV/Video Only',
              value: 9,
              selected: false
            },
            {
              label: 'Internet and Voice/Phone Only',
              value: 10,
              selected: false
            },
            {
              label: 'TV/Video and Voice/Phone Only',
              value: 11,
              selected: false
            },
            {
              label: 'Mobile/Wireless, Internet and TV/Video Only',
              value: 12,
              selected: false
            },
            {
              label: 'Mobile/Wireless, Internet and Voice/Phone Only',
              value: 13,
              selected: false
            },
            {
              label: 'Mobile/Wireless, TV/Video and Voice/Phone Only',
              value: 14,
              selected: false
            },
            {
              label: 'Internet, TV/Video, and Voice/Phone Only',
              value: 15,
              selected: false
            }
          ]
        }
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/scorecard/ScorecardView/ScorecardFilter/index.js